/* eslint-disable simple-import-sort/imports */
import { api } from '../../services/api';

export const getAllSolicitations = async (): Promise<[]> => {
  const response = await api.get(`/customer/solicitations`);
  return response.data;
};

export const sendSolicitation = async (payload: any) => {
  const response = await api.post('/customer/solicitations', payload);
  return response.data;
};

export const deleteSolicitation = async (id: number) => {
  const response = await api.delete(`/customer/solicitations/${id}`);
  return response.data;
};

export const getFilesFromSolicitation = async (uid: number) => {
  const response = await api.get(
    `/customer/files/solicitations/${uid}_response`
  );
  return response.data.data;
};
